import React, { Suspense, lazy } from 'react';
import { HeroSection } from './HeroSection';
import { SocialProofSection } from './SocialProofSection';
import { QuickTestimonials } from './QuickTestimonials';
import { ProblemSection } from './ProblemSection';
import { TransitionSection } from './TransitionSection';
import { SolutionSection } from './SolutionSection';
import { BonusesSection } from './BonusesSection';
import { LaunchUrgency } from './LaunchUrgency';
import { OfferStack } from './OfferStack';
import { UpsellComparison } from './UpsellComparison';
import { TestimonialsSection } from './TestimonialsSection';
import { GuaranteeSection } from './GuaranteeSection';
import { FAQSection } from './FAQSection';
import { FinalCTA } from './FinalCTA';
import { FooterSection } from './FooterSection';
// Lazy load the notification to keep initial bundle small
const PurchaseNotification = lazy(() => import('./PurchaseNotification').then(module => ({
  default: module.PurchaseNotification
})));
export function SalesPage() {
  return <div className="min-h-screen bg-black text-white font-inter selection:bg-soft-gold selection:text-black" data-id="element-227">
      {/* Preload the main hero image for LCP optimization */}
      <link rel="preload" as="image" href="https://cdn.magicpatterns.com/uploads/iqYt6Z98kV2R8DZ6kt6QxP/PT_BUSINESS__COACHING_KIT.png" data-id="element-228" />

      <HeroSection data-id="element-229" />
      <SocialProofSection data-id="element-230" />
      <QuickTestimonials data-id="element-231" />
      <ProblemSection data-id="element-232" />
      <TransitionSection data-id="element-233" />
      <SolutionSection data-id="element-234" />
      <BonusesSection data-id="element-235" />
      <LaunchUrgency data-id="element-236" />
      <OfferStack data-id="element-237" />
      <UpsellComparison data-id="element-238" />
      <TestimonialsSection data-id="element-239" />
      <GuaranteeSection data-id="element-240" />
      <FAQSection data-id="element-241" />
      <FinalCTA data-id="element-242" />
      <FooterSection data-id="element-243" />

      <Suspense fallback={null} data-id="element-244">
        <PurchaseNotification data-id="element-245" />
      </Suspense>
    </div>;
}